export interface ISelectionCreate {
  name: string;
  referenceLink: string;
  criterias: any; // TODO: chacgeType
  internalDescription?: string;
  patientDescription?: string;
  visibilityType: VisibilityTypes;
  createVisibility?: Nullable<IUpdateVisibility>;
}

export interface IUpdateVisibility {
  salesRepresentativeId?: Nullable<string>;
  intersectionType?: /* IntersectionType */ string;
  facilityVisibilities?: {
    facilityId?: string;
    orderingProviderIds?: (string | undefined)[];
  }[];
}

export interface ISelectionList {
  selectionItems: ISelectionItem[];
}

export interface FileItem {
  fileId: string;
  expirationDate: string;
}

export enum FileType {
  ExcelReport = 'ExcelReport',
  PdfReport = 'PdfReport',
  PdfRequisition = 'PdfRequisition',
}

export enum NameFileType {
  ExcelReport = 'XLSX',
  PdfReport = 'PDF Report',
  PdfRequisition = 'PDF Requisition',
}

type VisibilityType = 'ForMe' | 'ForAll' | 'ForOneSalesRepresentative' | 'ForOrderingProviders';

export interface FileItem {
  fileId: string;
  expirationDate: string;
  fileType: FileType;
}

export interface GenerationTaskDetails {
  generationTaskId: number;
  patientsCount: number;
  selectionResultFileItems: FileItem[];
}

export interface ISelectionItem {
  id: number;
  lastEdit: string;
  name: string;
  internalDescription: string;
  expirationDate: string;
  hasActiveGenerationTask: boolean;
  visibilityType: VisibilityType;
  generationTaskDetails: Nullable<GenerationTaskDetails>;
  patientDescription: Nullable<string>;
  isEditable: boolean;
}

export interface ISelectionListRequest {
  search: string;
  skip: number;
  take: number;
  orderBy?: [
    {
      orderBy: string;
      orderDesc: boolean;
    },
  ];
}

export interface ISelectionScope {
  isAllLaboratories: boolean;
  isAllOrderingProviders: boolean;
  salesRepresentative: Nullable<{
    name: string;
    id: string;
  }>;
}

export interface IPatientItem {
  id: string;
  patientId: Nullable<string>;
  firstName: Nullable<string>;
  lastName: Nullable<string>;
  middleName: Nullable<string>;
  birthDate: Nullable<string>;
}

export interface IMissingOrderProducts {
  loincItem: null | { id: string; code: Nullable<string>; longCommonName: Nullable<string> };
  product: null | { id: string; code: Nullable<string>; name: Nullable<string> };
}

export interface ILabSearch {
  id: string;
  name: Nullable<string>;
}

export interface IProductSearch {
  id: string;
  name: Nullable<string>;
  code: Nullable<string>;
}

export interface IOrderingProviderForOrder {
  id: string;
  accountId: string;
  firstName: Nullable<string>;
  lastName: Nullable<string>;
}

export interface IBulkOrderBody {
  laboratoryId: string;
  providerId: Nullable<string>;
  additionalProductIds: Nullable<string[]>;
  diagnosisIds: Nullable<string[]>;
  patientIds: Nullable<string[]>;
  productsByLoincItems: Nullable<{ loincItemId: string; productId: Nullable<string> }[]>;
}

export enum VisibilityTypes {
  ForMe = 'ForMe',
  ForAll = 'ForAll',
  ForOneSalesRepresentative = 'ForOneSalesRepresentative',
  ForOrderingProviders = 'ForOrderingProviders',
}

export enum RuleTypes {
  PatientAgeRule = 'PatientAgeRule',
  PatientBirthSexRule = 'PatientBirthSexRule',
  ResultRefValueRule = 'ResultReferenceValueRule',
  ResultRule = 'ResultRule',
  MissingResultRule = 'MissingResultRule',
  ConditionAndDiagnosisRule = 'ConditionAndDiagnosisRule',
  CriteriaRuleGroup = 'CriteriaRuleGroup',
}

export enum RuleOperationType {
  And = 'And',
  Or = 'Or',
}

export enum Operations {
  LessOrEqual = 'LessOrEqual',
  Less = 'Less',
  NotEqual = 'NotEqual',
  Equals = 'Equals',
  Greater = 'Greater',
  GreaterOrEqual = 'GreaterOrEqual',
}

export enum OperatinonsSign {
  LessOrEqual = '≤',
  Less = '<',
  NotEqual = '≠',
  Equals = '',
  Greater = '>',
  GreaterOrEqual = '≥',
}

export enum CriteriaTime {
  Day = 'Day',
  Week = 'Week',
  Month = 'Month',
}

export enum ResultFlag {
  CriticalHigh = 'CriticalHigh',
  CriticalLow = 'CriticalLow',
  Normal = 'Normal',
  Abnormal = 'Abnormal',
  AbnormalHigh = 'AbnormalHigh',
  AbnormalLow = 'AbnormalLow',
}

export enum ResultFlagName {
  CriticalHigh = 'Critical High',
  CriticalLow = 'Critical Low',
  Normal = 'Normal',
  Abnormal = 'Abnormal',
  AbnormalHigh = 'Abnormal High',
  AbnormalLow = 'Abnormal Low',
}

export enum ResultValueType {
  Single = 'Single',
  Range = 'Range',
}

export enum BirthSex {
  Female = 'Female',
  Male = 'Male',
  Unknown = 'Unknown',
}
